import { Input, InputWrapper } from '@recruit-robin/robin-theme/web-components';

import { useDictionary } from '@/shared/lib/i18n';
import { FadeIn } from '../FadeIn';
import { InterviewError, InterviewValue } from '../InterviewTypeSelection.types';
import { useStyles } from './InterviewForm.styles';

type CallInterviewProps = {
  value: InterviewValue;
  onChange: (value: InterviewValue) => void;
  error?: InterviewError;
};

export const CallInterview = ({ value, onChange, error }: CallInterviewProps) => {
  const classes = useStyles();
  const dictionary = useDictionary();

  return (
    <FadeIn css={classes.selectionResult}>
      <InputWrapper label={dictionary.phone} error={error?.phone.error} contained>
        <Input
          value={value.phone ?? ''}
          onChange={(e) => {
            error?.phone.reset();
            onChange({ ...value, phone: e.target.value });
          }}
          placeholder={dictionary.phonePlaceholder}
          contained
        />
      </InputWrapper>
    </FadeIn>
  );
};
